import { useSelector } from 'react-redux'

import { selectIsInternalAdmin } from '../../../accessors'
import { SIDEBAR_NAV_MODES } from '../../../components/sidebarNavMode'
import useSidebarNavMode from '../../../components/useSidebarNavMode'
import campaignNames, {
  campaignNamesForInternalAdmin,
  campaignsDescriptions
} from '../../../main/campaignNamesAndDesc'

export function useCampaignName(key) {
  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const [navMode] = useSidebarNavMode()
  const isNewNav = navMode === SIDEBAR_NAV_MODES.new

  let name = isInternalAdmin
    ? campaignNamesForInternalAdmin[key] || key
    : campaignNames[key] || key

  if (isNewNav && key === 'ServiceStartForPrimaryGuest') {
    name = 'After check-in'
  }

  const desc = campaignsDescriptions[key] || ''

  return [name, desc]
}
